import { render, staticRenderFns } from "./System.vue?vue&type=template&id=2e723ee5&scoped=true"
import script from "./System.vue?vue&type=script&lang=js"
export * from "./System.vue?vue&type=script&lang=js"
import style0 from "./System.vue?vue&type=style&index=0&id=2e723ee5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e723ee5",
  null
  
)

export default component.exports